import { getFlexibleLife, getFlexibleLife20 } from "../../api/flexiblelife";
import store from "@/store";

const getDefaultState = () => {
    return {
        all: {},
    };
};

const state = getDefaultState();

const getters = {};

const actions = {
    getFlexibleLife({ commit, state }, contractId) {
        return new Promise((resolve) => {
            if (
                (contractId in state.all &&
                    Object.keys(state.all[contractId]).length === 0) ||
                !(contractId in state.all)
            ) {
                commit("setLoading", true, { root: true });
            }
            getFlexibleLife(contractId)
                .then((response) => {
                    if (response.data.Status === 200) {
                        commit("setFlexibleLife", {
                            contractId: contractId,
                            flexiblelife: response.data.Result,
                        });
                    } else {
                        store.cache.delete(
                            "flexiblelife/getFlexibleLife",
                            contractId
                        );
                    }
                })
                .catch(() => {
                    store.cache.delete(
                        "flexiblelife/getFlexibleLife",
                        contractId
                    );
                })
                .finally(() => {
                    resolve();
                });
        });
    },
    getFlexibleLife20({ commit, state }, contractId) {
        return new Promise((resolve) => {
            if (
                (contractId in state.all &&
                    Object.keys(state.all[contractId]).length === 0) ||
                !(contractId in state.all)
            ) {
                commit("setLoading", true, { root: true });
            }
            getFlexibleLife20(contractId)
                .then((response) => {
                    if (response.data.Status === 200) {
                        commit("setFlexibleLife", {
                            contractId: contractId,
                            flexiblelife: response.data.Result,
                        });
                    } else {
                        store.cache.delete(
                            "flexiblelife/getFlexibleLife20",
                            contractId
                        );
                    }
                })
                .catch(() => {
                    store.cache.delete(
                        "flexiblelife/getFlexibleLife20",
                        contractId
                    );
                })
                .finally(() => {
                    resolve();
                });
        });
    },
};

const mutations = {
    resetState(state) {
        Object.assign(state, getDefaultState());
    },
    setFlexibleLife(state, payload) {
        state.all = {
            ...state.all,
            [payload.contractId]: payload.flexiblelife,
        };
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
